import type {
  PaginateVirtualToursV2DTO,
  VirtualTourJsonType,
} from '@bb/domain/dist/types';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type PaginateVirtualToursOptions = {
  limit?: number;
  listingId: string;
  page?: number;
  isDesc?: boolean;
  sortField?: keyof VirtualTourJsonType;
  withCoopData?: boolean;
};

// @TODO: Move into VirtualTourController file
const paginateVirtualTours = async ({
  limit,
  page = 0,
  listingId,
  isDesc,
  sortField,
  withCoopData,
}: PaginateVirtualToursOptions) => {
  const config: AxiosRequestConfig = {
    url: `/listing/${listingId}/virtual_tour/paginate`,
    method: 'get',
    params: {
      limit,
      // BE starts counting from 1
      page: page + 1,
      isDesc,
      sortField,
      withCoopData,
    },
  };

  const { data } = await axios.request<PaginateVirtualToursV2DTO>(config);

  return data;
};

export default paginateVirtualTours;
